export default __webpack_public_path__ + "static/media/S-006.e655e93f.png";